import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../environments/environment';

@Injectable()
export class WorkFromHomeService {

  headers;

  constructor(
    private http: HttpClient
  ) { }

  /* Getting Headers */
  getHeaders() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    });
  }


  /* Getting Headers For Report */
  getHeadersForReport() {
    this.headers = new HttpHeaders({
      'Content-Type': 'text/csv',
      'Accept': '*/*',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    });
  }

  /* Setting Headers */
  setHeaders(data) {
    if (data.headers.get('access-token') != null) {
      localStorage.setItem('access-token', data.headers.get('access-token'));
      localStorage.setItem('client', data.headers.get('client'));
      localStorage.setItem('expiry', data.headers.get('expiry'));
      localStorage.setItem('uid', data.headers.get('uid'));
    }
  }

  /* Apply WFH/permission API */
  applyWFH(payloads): Observable<any> {
    this.getHeaders();
    return this.http.post(environment.api_url + '/work_from_homes', payloads, { headers: this.headers, observe: 'response' });
  }

  /* Get self WFH/permission List */
  getSelfWFHList(pageNo, type, status, time): Observable<any> {
    this.getHeaders();

    let params = `?self=true&filter=true`;
    params += (type && type != 'all') ? `&permission_type=${type}` : '';
    params += (pageNo) ? `&page_no=${pageNo}` : '&page_no=1';
    params += (status && status != 'all') ? `&status=${status}` : '';
    params += time;

    return this.http.get(environment.api_url + '/work_from_homes' + params, { headers: this.headers, observe: 'response' });
  }

  /* Get Team WFH/permission List */
  getTeamWFHList(pageNo, filterBy, type, status, time): Observable<any> {
    this.getHeaders();

    let params = `?team=true&filter=true`;
    params += (filterBy && filterBy != 'all') ? `&account_id=${filterBy}` : '';
    params += (type && type != 'all') ? `&permission_type=${type}` : '';
    params += (pageNo) ? `&page_no=${pageNo}` : '&page_no=1';
    params += (status && status != 'all') ? `&status=${status}` : '';
    params += time;

    return this.http.get(environment.api_url + '/work_from_homes' + params, { headers: this.headers, observe: 'response' });
  }

  /* Get WFH/permission Record */
  getWFHRecordById(recordId): Observable<any> {
    this.getHeaders();
    return this.http.get(environment.api_url + '/work_from_homes/' + recordId, { headers: this.headers, observe: 'response' });
  }

  /* Update WFH/permission Record */
  updateWFHRecord(payloads): Observable<any> {
    this.getHeaders();
    return this.http.put(environment.api_url + '/work_from_homes/' + payloads.work_from_home.id, payloads, { headers: this.headers, observe: 'response' });
  }


  /* Delete WFH/permission Record */
  deleteWFHRecord(recordId): Observable<any> {
    this.getHeaders();
    return this.http.delete(environment.api_url + '/work_from_homes/' + recordId, { headers: this.headers, observe: 'response' });
  }

  /* Get Admin WFH/permission Summary */
  getWFHAdminSummary(pageNo, filterBy, type, status, time): Observable<any> {
      this.getHeaders();

      let params = `?&filter=true`;
      params += (filterBy && filterBy != 'all') ? `&account_id=${filterBy}` : '';
      params += (type && type != 'all') ? `&permission_type=${type}` : '';
      params += (pageNo) ? `&page_no=${pageNo}` : '&page_no=1';
      params += (status && status != 'all') ? `&status=${status}` : '';
      params += time;

      return this.http.get(environment.api_url + '/work_from_homes/summary' + params, { headers: this.headers, observe: 'response' });
  }

   /* Get Admin WFH/permission Report */
   getWFHAdminReport(filterBy, type, status, time): Observable<any> {
    this.getHeadersForReport();

    let params = `?&filter=true`;
    params += (filterBy && filterBy != 'all') ? `&account_id=${filterBy}` : '';
    params += (type && type != 'all') ? `&permission_type=${type}` : '';
    params += (status && status != 'all') ? `&status=${status}` : '';
    params += time;

    return this.http.get(environment.api_url + '/work_from_homes/export_csv' + params, { headers: this.headers, observe: 'response',responseType:'blob' });
  }
  /* Get Project list */
  getProjects(defaultValue?, pageNo?, search?, order?, orderType?): Observable<any> {
    this.getHeaders();
    let query = '/projects';
    if (defaultValue != null) {
      query += '?default=' + defaultValue + (pageNo ? '&page=' + pageNo : '') + (search ? '&search=' + search : '') + (order ? '&order=' + order : '') + (orderType ? '&order_type=' + orderType : '');
    }
    return this.http.get(environment.api_url + query, {headers: this.headers,  observe: 'response'} );
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/services/work-from-home/work-from-home.service.ts